import { useQuery } from '@tanstack/react-query';
import { PUBLIC_AI_API } from 'utils/globalApiServices';
import PublicRealPlayHelper from 'features/publicRoleplay/publicRealPlay.helper';

const queryFn = async ({ assignment_uuid, scenario_uuid, session_uuid }) => {
  const url = `/public/realplays/assignments/${assignment_uuid}/scenarios/${scenario_uuid}/sessions/${session_uuid}/`;
  const { data } = await PUBLIC_AI_API.get(url);
  return data || [];
};

const useGetPublicSessionQuery = ({ assignment_uuid, scenario_uuid, session_uuid, enabled }) => {
  const { updateSessionStatus } = PublicRealPlayHelper();
  return useQuery({
    queryFn: () => queryFn({ assignment_uuid, scenario_uuid, session_uuid }),
    queryKey: ['SESSION_INTERACTION__PUBLIC_INFO'],
    enabled,
    onSuccess: (response) => {
      updateSessionStatus(response?.status);
    },
  });
};

export default useGetPublicSessionQuery;
